/* Gift details V1.1.1 | Created: 2026-10-20 | Updated: 2026-10-21
 * Reuse product images with current gift variant first; keep selection and detail tabs unchanged. */
(function () {
  'use strict';
  if (window.RBNLGiftDetails) return;
  function el(tag, text, name) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (name) node.className = name;
    return node;
  }
  function giftImageMatches(gift, image) {
    const bindings = image.variants || [];
    if (bindings.length && !bindings.some(v => String(v.id) === String(gift.id))) return false;
    // ponytail: this legacy bell gallery mislabels blue/black images as Red.
    // Only the visually reviewed red usage image is shared; expand after image review.
    if (gift.sku === 'CB1709RD') return String(image.id) === String(gift.imageId) || String(image.id) === '35616969850946';
    return true;
  }
  function descriptionContent(gift, fallback) {
    const content = el('div', undefined, 'rcf-gift-detail__description');
    if (!gift.descriptionHtml?.trim()) {
      content.textContent = gift.description?.trim() || fallback;
      return content;
    }
    const template = document.createElement('template');
    template.innerHTML = gift.descriptionHtml;
    template.content.querySelectorAll('script,style,iframe,object,embed,form,svg,link,meta,base,input,button,textarea').forEach(node => node.remove());
    template.content.querySelectorAll('*').forEach(node => {
      for (const attribute of [...node.attributes]) {
        const name = attribute.name.toLowerCase();
        const value = attribute.value.replace(/[\s\u0000-\u001f]/g, '').toLowerCase();
        if (name.startsWith('on') || ['style','srcdoc','srcset'].includes(name) ||
          (['href','src','xlink:href'].includes(name) && /^(javascript|vbscript|data):/.test(value))) node.removeAttribute(attribute.name);
      }
      if (node.tagName === 'IMG') { node.loading = 'lazy'; node.decoding = 'async'; }
      if (node.tagName === 'A') node.setAttribute('rel', 'noopener noreferrer');
    });
    content.append(template.content);
    return content;
  }
  class GiftDetails {
    constructor(campaign) {
      this.c = campaign;
      this.dialog = el('dialog', undefined, 'rcf-gift-detail');
      const header = el('header', undefined, 'rcf-gift-detail__header');
      header.append(el('span', 'Ontdek je gratis cadeau'));
      const close = el('button', '×', 'rcf-gift-detail__close');
      close.type = 'button'; close.setAttribute('aria-label', 'Cadeaudetails sluiten');
      close.addEventListener('click', () => this.dialog.close()); header.append(close);
      const body = el('div', undefined, 'rcf-gift-detail__body');
      this.image = el('img'); this.image.width = 640; this.image.height = 640;
      this.image.decoding = 'async';
      this.image.addEventListener('error', () => { this.image.hidden = true; });
      const media = el('div', undefined, 'rcf-gift-detail__media');
      this.thumbnails = el('div', undefined, 'rcf-gift-detail__thumbnails');
      this.thumbnails.setAttribute('role', 'group'); this.thumbnails.setAttribute('aria-label', 'Productafbeeldingen');
      this.caption = el('p', undefined, 'rcf-gift-detail__caption'); this.caption.setAttribute('aria-live', 'polite');
      media.append(this.image, this.thumbnails, this.caption);
      const info = el('div', undefined, 'rcf-gift-detail__info');
      this.title = el('h2'); this.title.id = 'gift-detail-title-' + campaign.id;
      this.dialog.setAttribute('aria-labelledby', this.title.id);
      this.variant = el('p', undefined, 'rcf-gift-detail__variant');
      this.value = el('p', undefined, 'rcf-gift-detail__value');
      this.sideLabel = el('label', 'Kies je spiegel', 'rcf-gift-detail__side');
      this.side = el('select'); this.side.setAttribute('aria-label', 'Kies links of rechts'); this.sideLabel.append(this.side);
      this.side.addEventListener('change', () => { this.variantId = this.side.value; this.render(); });
      this.description = el('div', undefined, 'rcf-gift-detail__description');
      this.full = el('a', 'Bekijk de volledige productpagina ↗', 'rcf-gift-detail__link');
      this.full.target = '_blank'; this.full.rel = 'noopener';
      info.append(this.title, this.variant, this.value, this.sideLabel, this.description, this.full);
      body.append(media, info);
      const footer = el('footer', undefined, 'rcf-gift-detail__footer');
      this.note = el('p'); this.note.setAttribute('role', 'status');
      this.choose = el('button', 'Kies dit cadeau', 'rcf-gift-detail__choose'); this.choose.type = 'button';
      this.choose.addEventListener('click', () => this.select());
      footer.append(this.note, this.choose);
      this.dialog.append(header, body, footer); campaign.append(this.dialog);
      this.dialog.addEventListener('close', () => {
        this.c.querySelector(`[data-gift-view="${this.key}"]`)?.focus();
      });
      const render = campaign.render.bind(campaign);
      campaign.render = () => { render(); if (this.dialog.open) this.render(); };
    }
    open(key) {
      const gift = this.c.gift(key);
      if (!gift) return;
      this.key = key; this.variantId = String(gift.id); this.galleryGift = null; this.render();
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.querySelector('.rcf-gift-detail__body').scrollTop = 0;
    }
    render() {
      const c = this.c, gift = c.gifts.find(g => g.key === this.key && String(g.id) === this.variantId);
      if (!gift) return;
      this.title.textContent = gift.title || c.t(this.key);
      const variant = gift.variantTitle && gift.variantTitle !== 'Default Title' ? gift.variantTitle : c.t(this.key + '_detail');
      this.variant.textContent = variant;
      this.value.textContent = `Waarde ${c.money(gift.price)} · Gratis bij een geldige cadeaukeuze`;
      if (this.galleryGift !== gift) {
        this.galleryGift = gift;
        const current = gift.detailImage || gift.image;
        const images = Array.isArray(gift.images) ? gift.images : [];
        this.gallery = current ? [{src: current, thumb: gift.image || current, alt: gift.title, caption: 'Geselecteerd cadeau · ' + variant}] : [];
        for (const image of images) {
          if (!image.src || String(image.id) === String(gift.imageId) || !giftImageMatches(gift, image)) continue;
          const caption = 'Productdetail';
          this.gallery.push({src: image.src, thumb: image.thumb || image.src, alt: image.alt || gift.title, caption});
        }
        this.thumbnails.replaceChildren();
        this.gallery.forEach((image, index) => {
          const button = el('button'); button.type = 'button';
          button.setAttribute('aria-label', `Afbeelding ${index + 1}: ${image.caption}`);
          const thumb = el('img'); thumb.src = image.thumb; thumb.alt = ''; thumb.width = 56; thumb.height = 56; thumb.loading = 'lazy'; thumb.decoding = 'async';
          button.append(thumb); button.addEventListener('click', () => this.showImage(index));
          this.thumbnails.append(button);
        });
        this.thumbnails.hidden = this.gallery.length < 2;
        this.showImage(0);
      }
      if (this.descriptionGift !== gift) {
        this.descriptionGift = gift;
        const content = descriptionContent(gift, c.t(this.key + '_detail'));
        this.description.replaceWith(content); this.description = content;
        const details = window.RBNLProductDetails;
        if (details) {
          details.format(content); details.tabs(content);
          details.loadSpecs(content, gift.url).then(() => {
            if (this.description === content && content.isConnected) details.tabs(content);
          });
        }
      }
      this.full.hidden = true;
      if (gift.url) {
        const url = new URL(gift.url, location.origin);
        if (url.origin === location.origin) { url.searchParams.set('variant', String(gift.id)); this.full.href = url.href; this.full.hidden = false; }
      }
      this.sideLabel.hidden = this.key !== 'mirror';
      this.side.replaceChildren();
      for (const mirror of c.gifts.filter(g => g.key === 'mirror')) {
        const option = el('option', `${c.t(mirror.sku === '26210007001' ? 'left' : 'right')}${mirror.available ? '' : ' · ' + c.t('sold')}`);
        option.value = String(mirror.id); option.selected = option.value === this.variantId; option.disabled = !mirror.available;
        this.side.append(option);
      }
      this.side.disabled = c.busy;
      const limit = c.cartAmount >= 6900 ? 2 : 1;
      const already = c.state.selected.includes(this.key) && (this.key !== 'mirror' || String(c.state.mirror) === this.variantId);
      const full = !c.state.selected.includes(this.key) && limit === 2 && c.state.selected.length >= limit;
      this.choose.disabled = c.busy || !gift.available || full;
      this.choose.textContent = c.busy ? 'Even wachten…' : !gift.available ? 'Momenteel niet beschikbaar' : already ? 'Gekozen — terug naar je cadeaus' : 'Kies dit cadeau';
      this.note.textContent = full ? 'Je hebt al 2 cadeaus gekozen. Maak eerst een keuze vrij om dit cadeau te kiezen.' : 'Bekijk, kies en bevestig je gratis cadeau bij het afrekenen.';
    }
    showImage(index) {
      const image = this.gallery[index];
      this.image.hidden = !image; this.caption.hidden = !image;
      if (!image) return;
      this.image.src = image.src; this.image.alt = image.alt;
      this.caption.textContent = `${index + 1} / ${this.gallery.length} · ${image.caption}`;
      [...this.thumbnails.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    async select() {
      if (this.choose.disabled) return;
      const c = this.c, limit = c.cartAmount >= 6900 ? 2 : 1;
      const gift = c.gifts.find(g => String(g.id) === this.variantId && g.key === this.key);
      if (!gift?.available || c.busy) return;
      const selected = c.state.selected.slice();
      if (!selected.includes(this.key)) {
        if (limit === 1) selected.splice(0, selected.length, this.key);
        else if (selected.length < limit) selected.push(this.key);
        else return;
      }
      const changed = selected.join('+') !== c.state.selected.join('+') || (this.key === 'mirror' && String(c.state.mirror) !== this.variantId);
      if (changed) {
        c.state.selected = selected;
        if (this.key === 'mirror') c.state.mirror = this.variantId;
        c.selectionChanged = true; c.save(); c.render();
      }
      this.dialog.close();
      if (changed) await c.refreshCart();
      c.querySelector(`[data-gift-view="${this.key}"]`)?.focus();
    }
  }
  window.RBNLGiftDetails = GiftDetails;
  function mount() {
    for (const c of document.querySelectorAll('rb-clearance-festival')) {
      if (!c.giftDetails && c.state && c.gifts) c.giftDetails = new GiftDetails(c);
    }
  }
  customElements.whenDefined('rb-clearance-festival').then(mount);
  document.addEventListener('shopify:section:load', mount);
})();

